module.exports = __webpack_public_path__ + "components/home-header/static/header-4--small@2x-12a2f7c49053327d1dfaf5b6b580e6f1.jpg";